import { useRef, useState } from 'react';
import './Header.css';
import logo from './docWindows.png';
import NavMenu from './navMenu/NavMenu';
import { useIconColor } from '../hooks/useIconsColor';
import { useGlobalContext } from '../../context/GlobalContext';
import Navigator from '../../utils/Navigator';
import { MessageDialog } from '../messagebox/MessageBox';
import { CurrentUser } from '../login/CurrentUser';
import Tooltip from '../tooltip/Tooltip';


export default function Header() {
    let context = useGlobalContext();
    let [menuVisibility, setMenuVisibility] = useState(false);

    return (
        <>
            <header className="HeaderComponent">

                <div className='HeaderLeftMenu'>
                    {window.location.pathname != '/' &&

                        <Tooltip text='Voltar para o Dashboard' width={150} onChildrenElementClicked={() => {
                            Navigator.NavigateToHome();
                        }}>

                            <i className="header-icon pi pi-angle-left" style={{ marginRight: '5px' }}></i>

                        </Tooltip>

                    }
                    <img src={logo} style={{ width: '30px', borderRadius: '7px' }} />
                    <h1>DOC-Mobile</h1>

                </div>
                <div>

                    <Tooltip text='Voltar para tela de login' mode='RIGHT' width={150} onChildrenElementClicked={() => {

                        MessageDialog.Show({
                            Message: "Deseja sair e voltar para tela de Login?",
                            OKText: "Sair",
                            Canceltext: "Cancelar",
                            Title: "Atenção",
                            OKClickEvent: CurrentUser.LogOff,
                            IsOpen: true
                        });

                    }}>
                        <i className='header-icon pi pi-sign-out'
                            style={{ marginRight: '10px' }}></i>
                    </Tooltip>

                    <Tooltip text='Alterar o tema do app' mode='RIGHT' width={150} onChildrenElementClicked={() => {
                        context.Context?.ToogleTheme!();
                    }}>

                        <i className="header-icon pi pi-sun" style={{ marginRight: '10px' }}></i>

                    </Tooltip>
                    <Tooltip text='Abrir o menu de gráficos' mode='RIGHT' width={160} onChildrenElementClicked={() => {
                        setMenuVisibility(!menuVisibility);
                    }}>

                        <i className={menuVisibility ? "header-icon pi pi-times" : "header-icon pi pi-ellipsis-v"} style={{ marginRight: '10px' }}></i>
                    </Tooltip>

                </div>

            </header>
            <NavMenu Show={menuVisibility} />
        </>
    )
}